import classNames from 'classnames'

import { toCSSPixel } from '../../../utils/styles'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../Checkbox'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../Icon'

import * as styles from './UploadingTableRowActions.module.css'

import DragDropIcon from '../../../icons/drag-and-drop.svg'

function UploadingTableRowActions({
  className = styles.UploadingTableRowActions,
  disabled,
  width,
  ...restProps
}) {
  return (
    <div className={className} style={{ width: toCSSPixel(width) }}>
      <Checkbox
        {...restProps}
        disabled={disabled}
        size={CHECKBOX_SIZE.small}
        type={CHECKBOX_TYPE.tableRow}
      />
      <IconNG
        Icon={DragDropIcon}
        className={classNames(styles.dragIcon, { [styles.disabled]: disabled })}
        color={ICON_COLOR.TextDisabledColor}
        size={ICON_HEIGHT_16}
      />
    </div>
  )
}

export default UploadingTableRowActions
